import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { ResourceType } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { ResourceTypeIndicator } from '@/components/cloudProviderIndicator';
import { MainDialog } from '@/components/dialogs/mainDialog';
export const SupportedResourceTypesText = t0 => {
  const $ = _c(15);
  const {
    resourceTypes
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = resourceTypes?.length;
  let t3;
  if ($[1] !== t2) {
    t3 = <Typography component="span" className="underline cursor-pointer" onClick={t1}>{t2} resource types</Typography>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      title: "Available resource types",
      onClose: () => setIsOpen(false)
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      flexWrap: "wrap",
      gap: "8px 100px",
      padding: "24px 40px",
      maxHeight: "400px",
      alignContent: "flex-start"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== resourceTypes) {
    t6 = resourceTypes?.map(_temp);
    $[5] = resourceTypes;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <Stack direction="column" sx={t5}>{t6}</Stack>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isOpen || $[10] !== t7) {
    t8 = <MainDialog isOpen={isOpen} header={t4} isLoading={false}>{t7}</MainDialog>;
    $[9] = isOpen;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t8) {
    t9 = <>{t3}{t8}</>;
    $[12] = t3;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export const AvailableForText = t0 => {
  const $ = _c(4);
  const {
    resourceTypes
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "4px",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography align="center" sx={{
      padding: "12px 0px"
    }}>Available for</Typography>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== resourceTypes) {
    t3 = <Stack direction="row" sx={t1}>{t2}<SupportedResourceTypesText resourceTypes={resourceTypes} /></Stack>;
    $[2] = resourceTypes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(resourceType) {
  return <ResourceTypeIndicator key={resourceType} resourceType={resourceType} />;
}